// extracted by mini-css-extract-plugin
module.exports = {"picture":"TeacherPreview_picture__1EIKX"};